import intersection from "lodash.intersection";

export const intersects = (a?: any[], b?: any[]): boolean =>
    !!intersection(a || [], b || []).length;

export const operators = {
    AND: (...items: Array<{ list: any[]; comparison(pl: any): boolean }>) =>
        items.every((item) => item.list.every((l) => item.comparison(l))),
    OR: (...items: Array<{ list: any[]; comparison(pl: any): boolean }>) =>
        items.some(
            (item) =>
                ((!item.list || !item.list.length) &&
                    items.every((everyList) => !everyList.list.length)) ||
                item.list.some((l) => item.comparison(l)),
        ),
};
